module.exports = __webpack_public_path__ + "img/lender_benefit_sharing.83b90327.jpg";